'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('../style/CardImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardImage = function CardImage(_ref) {
  var square = _ref.square,
      rectangle = _ref.rectangle,
      imageSrc = _ref.imageSrc,
      imageAlt = _ref.imageAlt,
      presentational = _ref.presentational,
      exitUrl = _ref.exitUrl;

  var className = (0, _classnames2.default)('cp-card-image', {
    square: square,
    rectangle: rectangle
  });

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'a',
      { href: exitUrl, className: 'link-solid-true-underline-grey' },
      _react2.default.createElement('img', { src: imageSrc, alt: imageAlt, 'aria-hidden': presentational })
    )
  );
};

CardImage.propTypes = {
  imageAlt: _react.PropTypes.string,
  imageSrc: _react.PropTypes.string.isRequired,
  presentational: _react.PropTypes.bool,
  square: _react.PropTypes.bool,
  rectangle: _react.PropTypes.bool,
  exitUrl: _react.PropTypes.string
};

CardImage.defaultProps = {
  square: false,
  rectangle: false,
  presentational: true,
  imageAlt: ''
};

exports.default = CardImage;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/base/lib/components/CardImage.js
// module id = 584
// module chunks = 5 9